document.addEventListener('DOMContentLoaded', () => {
  // Auto-init Splide sliders with class .js-splide
  const splides = document.querySelectorAll('.js-splide');
  if(splides.length && typeof Splide !== 'undefined'){
    splides.forEach(splideEl => {
      // Allow data attributes for config override
      const options = JSON.parse(splideEl.getAttribute('data-splide-options') || '{}');
      new Splide(splideEl, options).mount();
    });
  }

  // Smooth scroll for internal links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop,
          behavior: 'smooth'
        });
      }
    });
  });

  // Sticky Header Logic (Reveal on Scroll Up)
  let lastScrollY = window.scrollY;
  const header = document.querySelector('.kp-header, .pp-header, .plan-pros-header, .sgs-header');

  if (header) {
    // Get precise heights of header and announcement bar
    const getHeights = () => {
      const announcement = header.parentElement.querySelector('.kp-announcement, .pp-announcement, .plan-pros-announcement');
      const hHeight = header.getBoundingClientRect().height;
      const aHeight = announcement ? announcement.getBoundingClientRect().height : 0;
      return { hHeight, aHeight, total: hHeight + aHeight };
    };

    let heights = getHeights();
    // Set initial CSS variable for header height
    document.documentElement.style.setProperty('--header-height', `${heights.hHeight}px`);

    window.addEventListener('resize', () => { 
      heights = getHeights();
      document.documentElement.style.setProperty('--header-height', `${heights.hHeight}px`);
    });

    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      const scrollThreshold = heights.total + 100;

      if (currentScrollY > scrollThreshold) {
        if (currentScrollY > lastScrollY) {
          // Scrolling Down - Hide
          if (!header.classList.contains('header-sticky')) {
            // First time becoming sticky - Hide instantly with no flick
            header.style.transition = 'none';
            header.classList.add('header-sticky', 'header-sticky--hidden');
            document.body.classList.add('has-sticky-header');
            header.offsetHeight; // Force browser reflow to apply styles instantly
            header.style.transition = ''; // Re-enable transition
          } else {
            header.classList.remove('header-sticky--visible');
            header.classList.add('header-sticky--hidden');
          }
          // Ensure mobile menu closes if user scrolls down and hides the main header
          if (typeof closeMobileMenu === 'function') {
            closeMobileMenu();
          }
        } else {
          // Scrolling Up - Reveal
          // Ensure classes are present
          header.classList.add('header-sticky');
          document.body.classList.add('has-sticky-header');
          header.classList.remove('header-sticky--hidden');
          header.classList.add('header-sticky--visible');
        }
      } else if (currentScrollY <= heights.total) {
        // At the top - Reset
        if (header.classList.contains('header-sticky')) {
          header.classList.remove('header-sticky', 'header-sticky--hidden', 'header-sticky--visible');
          document.body.classList.remove('has-sticky-header');
        }
      }
      lastScrollY = currentScrollY;
    }, { passive: true });
  }
});
